import { render, staticRenderFns } from "./leftsix.vue?vue&type=template&id=65112062&scoped=true&"
import script from "./leftsix.vue?vue&type=script&lang=js&"
export * from "./leftsix.vue?vue&type=script&lang=js&"
import style0 from "./leftsix.vue?vue&type=style&index=0&id=65112062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65112062",
  null
  
)

export default component.exports